import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Snackbar } from "@mui/material";
import { useAppointmentStore } from "../../stores/useAppointmentStore";
import DoctorSelectDropdown from "../../components/patient/DoctorSelectDropDown";
import SlotSelection from "../../components/patient/SlotSelection";
import AppointmentTable from "../../components/patient/AppointmentTable";
import ReasonInputDialog from "../../components/patient/ReasonInputDialog";
import AppointmentConfirmationDialog from "../../components/patient/AppointmentConfirmationDialog";

const PatientAppointmentsPage = () => {
  const { getAppointments, appointments, toastOpen, setToastOpen } =
    useAppointmentStore();
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [reasonDialogOpen, setReasonDialogOpen] = useState(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [reason, setReason] = useState("");

  useEffect(() => {
    getAppointments();
  }, [getAppointments]);

  const handleSlotSelect = (slot) => {
    setSelectedSlot(slot);
    console.log(slot);
    setReasonDialogOpen(true);
  };

  const handleReasonSubmit = (text) => {
    setReason(text);
    setReasonDialogOpen(false);
    setConfirmationOpen(true);
  };
  console.log(selectedDoctor);

  return (
    <Box p={2}>
      <Typography variant="h5" mb={2}>
        My Appointments
      </Typography>

      {/* Previous Appointments Table */}
      <AppointmentTable appointments={appointments} />

      {/* New Appointment Section */}
      <Box mt={4}>
        <Typography variant="h6" mb={1}>
          Schedule a New Appointment
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <DoctorSelectDropdown
              selectedDoctor={selectedDoctor}
              setSelectedDoctor={setSelectedDoctor}
            />
          </Grid>

          {selectedDoctor && (
            <Grid item xs={12}>
              <SlotSelection
                doctorId={selectedDoctor.id}
                onSlotSelect={handleSlotSelect}
              />
            </Grid>
          )}
        </Grid>
      </Box>

      {/* Reason Input Dialog */}
      <ReasonInputDialog
        open={reasonDialogOpen}
        onClose={() => setReasonDialogOpen(false)}
        onSubmit={handleReasonSubmit}
      />

      {/* Appointment Confirmation Dialog */}
      <AppointmentConfirmationDialog
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
        doctor={selectedDoctor}
        slot={selectedSlot}
        reason={reason}
      />
      <Snackbar
        open={toastOpen}
        autoHideDuration={3000}
        onClose={() => setToastOpen(false)}
        message="Appointment created successfully!"
      />
    </Box>
  );
};

export default PatientAppointmentsPage;
